export default __webpack_public_path__ + "static/media/toyota4.1d1c3a0a.png";